import styled from 'styled-components';

export const Label = styled.label`
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
`;
